var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAnimatedSpinner = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  preserveAspectRatio: "xMidYMid",
  viewBox: "0 0 100 100"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 50,
  r: 35,
  fill: "none",
  stroke: "currentColor",
  strokeDasharray: "164.93361431346415 56.97787143782138",
  strokeWidth: 10,
  transform: "rotate(178.136 50 50)"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  dur: "1.01010101010101s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "rotate",
  values: "0 50 50;360 50 50"
}))));
export default SvgAnimatedSpinner;